import React from 'react'
import { useCmsBlock } from '@bluheadless/ui-logic/src/hooks/cms/useCmsBlock'
import Block from './block'
import { number, string } from 'prop-types'

const CmsBlock = ({ id, identifier, className }) => {
	const { loading, error, content } = useCmsBlock({ id, identifier })

	if (loading) {
		return null // TODO: loading indicator
	}

	if (!content || error) {
		return null
	}

	return <Block className={className} content={content} />
}

CmsBlock.propTypes = {
	id: number,
	identifier: string,
}

export default CmsBlock
